export default __webpack_public_path__ + "static/media/791.301bf737.png";